import { ServiceIdentifier } from '../service-locator';
import { LogService } from './interfaces';

export * from './interfaces';

/**
 * The service locator identifier for the LogService interface.
 */
export const LOG_SERVICE = ServiceIdentifier.get<LogService>('LogService');
